<app-matching-missing-products-selector
  [data]="data"
  (completed)="onCompleted($event)"
  (cancelled)="onCancelled()">
</app-matching-missing-products-selector>
